import * as s from '~js/utils/selectors';
import * as c from '~js/utils/classes';

export class VideoBackground {
  constructor(container) {
    this.container = container;
    this.videoId = this.container.querySelector(s.selectors$q.videoId);
    this.videoPlayer = this.container.querySelector(s.selectors$q.videoPlayer);
    this.videoTemplate = this.container.querySelector(s.selectors$q.videoTemplate);
    this.videoPlayButton = this.container.querySelector(s.selectors$q.videoPlayButton);
    this.init();
  }

  init() {
    if (!this.videoId) return;

    /*
      Observe video element and pull it out from its template tag
    */
    const videoObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const videoMarkup = this.videoTemplate.innerHTML;
            this.videoPlayer.innerHTML = videoMarkup;
            this.video = this.container.querySelector(s.selectors$q.videoAutoplay);
            this.videoPlayer.classList.remove(c.classes$i.loading);
            this.container.classList.add(c.classes$i.paused);

            this.listen();

            // Stop observing element after it was animated
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '300px',
        threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
      }
    );

    videoObserver.observe(this.videoPlayer);

    // Force video autoplay button
    this.videoPlayButton.addEventListener('click', (event) => {
      event.preventDefault();
      this.video?.play();
    });
  }

  listen() {
    this.video.addEventListener('play', () => {
      this.container.classList.remove(c.classes$i.paused);
    });

    // Force video autoplay on iOS when Low Power Mode is On
    this.container.addEventListener(
      'touchstart',
      () => {
        this.video.play();
      },
      { passive: true }
    );
  }
}